import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Row, Col, message } from "antd";
import apiPath from "../../constants/apiPath";
import useRequest from "../../hooks/useRequest";
import Container from "react-bootstrap/Container";
import BackArrowIcon from "../../assets/images/arrow-back-page.svg";
import RightIcon from "../../assets/images/arrow-right-icon.svg";
import CreditCardIcon from "../../assets/images/credit-card-icon.svg";
import PaypalIcon from "../../assets/images/paypal-icon.svg";

const { Content } = Layout;

const SubscriptionIndex = () => {
  const [loading, setLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const { request } = useRequest();
  const navigate = useNavigate();

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const fetchPaymentMethods = () => {
    setLoading(true);
    request({
      url: apiPath.common.paymentMethod,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          setPaymentMethods(data.data.data || []);
        } else {
          message.error(data.message || "Failed to fetch payment methods");
        }
      },
      onError: (error) => {
        setLoading(false);
        message.error(error?.message || "An error occurred while fetching payment methods");
      },
    });
  };

  // Payment Icons Map
  const paymentIcons = {
    "credit-card": CreditCardIcon,
    "paypal": PaypalIcon,
  };

  const handleSelectMethod = (method) => {
    setSelectedMethod(method);
    setTimeout(() => {
      navigate(`/payment/${method}`);
    }, 200); // Slight delay for UI effect
  };

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Container>
          <Content className="subscription-layout">
            <div className="back-logo-header" onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
              <img src={BackArrowIcon} alt="Back" />
            </div>
            <Row>
              <Col span={24}>
                <div className="plan-main-headding">
                  <h6>Choose how to pay</h6>
                </div>
              </Col>
              <div className="payment-choose-card">
                <ul>
                  {paymentMethods.length > 0 ? (
                    paymentMethods.map((method) => (
                      <li
                        key={method.method}
                        onClick={() => handleSelectMethod(method.method)}
                        style={{
                          cursor: "pointer",
                          backgroundColor: selectedMethod === method.method ? "#ffffff" : "transparent",
                          transition: "background 0.3s ease",
                        }}
                      >
                        <div className="payment-proses-body">
                          <img src={paymentIcons[method.method] || CreditCardIcon} alt={method.name} />
                          {method.name}
                        </div>
                        <div className="right-arrow-icon">
                          <img src={RightIcon} alt="Right Arrow" />
                        </div>
                      </li>
                    ))
                  ) : (
                    <p>Loading payment methods...</p>
                  )}
                </ul>
              </div>
            </Row>
          </Content>
        </Container>
      </Layout>
    </>
  );
};

export default SubscriptionIndex;
